// KitError.ts

export default class ErrorMgr {
    static tag: string = "[KitError]";
    static webhookUrl: string = "";

    /**
     * 初始化错误处理器，设置 webhook URL 并添加全局错误监听器
     * @param webhookUrl - 飞书 webhook URL
     */
    static init(webhookUrl: string): void {
        this.webhookUrl = webhookUrl;

        // 捕获 JavaScript 执行错误
        // @ts-ignore
        window.onerror = (
            message: string,
            source: string,
            lineno: number,
            colno: number,
            error: Error | null
        ): boolean => {
            const errorMsg = `${this.tag} => err: ${message}, Source: ${source}, Line: ${lineno}, Column: ${colno}, Error Object: ${error}`;
            console.error(errorMsg);
            this.sendFeishuNotification(errorMsg, 'error');
            return true; // 阻止错误继续传播
        };
    }

    /**
     * 发送飞书通知
     * @param message - 错误信息
     * @param type - 错误类型（可选）
     */
    static sendFeishuNotification(message: string, type?: string): void {
        if (!this.webhookUrl) {
            console.warn(`${this.tag} webhookUrl 未设置，无法发送飞书通知`);
            return;
        }

        const text = type ? `[${type}] ${message}` : message;
        const payload = {
            msg_type: "text",
            content: {
                text: `url=${window.location.href}\n${text}`
            }
        };

        fetch(this.webhookUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        })
        .then(response => {
            if (!response.ok) {
                console.error("Failed to send Feishu notification");
            }
        })
        .catch(error => {
            console.error("Error while sending Feishu notification:", error);
        });
    }
}
